import SessionsPage from "./SessionsPage";

export default [
    {
        path: "/sessions",
        name: "sessions",
        component: SessionsPage
    }
]
